import CommHandler from './CommHandler';
import { config } from '../config';

const checkSuperadminStatus = async (email: string): Promise<boolean> => {
  try {
    const response = await CommHandler.request({
      url: `${config.apiBaseUrl}/user/checkSuperadmin`,
      method: 'Post',
      data: { email },
    });
    return response.data.isSuperadmin;
  } catch (error) {
    console.error('Error checking superadmin status:', error);
    return false;
  }
};

export default checkSuperadminStatus;
